import { WarningOutlined } from '@ant-design/icons';
import { Flex, Tag } from 'antd';

type Props = {
	family: string;
	compact?: boolean;
};

export default function FontFamilyUnavailableOption({ family, compact = false }: Props) {
	return (
		<Flex align="center" gap={6} style={{ minWidth: 0 }}>
			<WarningOutlined style={{ flex: 'none', color: 'var(--ra-color-error)' }} />
			<span className="text-ellipsis">{family}</span>
			{compact ? null : (
				<Tag color="error" bordered={false} style={{ flex: 'none', marginInlineEnd: 0 }}>
					Unavailable
				</Tag>
			)}
		</Flex>
	);
}
